import React, { useMemo } from "react";

export default function RoutesEfficiencyChart({ routes = [] }) {
  const stats = useMemo(() => {
    return routes.map((r) => {
      const receipts = r.receipts || [];
      const total = receipts.length;
      const delivered = receipts.filter((x) => x.status === "Закрыта").length;
      const failed = receipts.filter((x) => x.status === "Не доставлено").length;
      const percentDelivered = total ? (delivered / total) * 100 : 0;
      const percentFailed = total ? (failed / total) * 100 : 0;
      return {
        route: `#${r.route_number || "?"}`,
        delivered,
        failed,
        total,
        percentDelivered,
        percentFailed,
      };
    });
  }, [routes]);

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: 16,
        boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
      }}
    >
      <h3 style={{ marginTop: 0 }}>Эффективность маршрутов</h3>
      <p style={{ color: "#666", marginBottom: 10 }}>
        Сравнение доставленных и недоставленных заказов.
      </p>

      {stats.length === 0 ? (
        <p style={{ color: "#999" }}>Нет данных о маршрутах.</p>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            maxHeight: 240,
            overflowY: "auto",
          }}
        >
          {stats.map((r, i) => (
            <div key={i}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 13,
                  marginBottom: 4,
                }}
              >
                <span>{r.route}</span>
                <span style={{ color: "#555" }}>
                  {r.delivered}/{r.total} доставлено
                </span>
              </div>
              <div
                style={{
                  height: 10,
                  background: "#eee",
                  borderRadius: 5,
                  overflow: "hidden",
                  display: "flex",
                }}
              >
                <div
                  style={{
                    width: `${r.percentDelivered}%`,
                    background: "#27ae60",
                    transition: "width 0.3s",
                  }}
                  title={`Доставлено: ${r.delivered}`}
                />
                <div
                  style={{
                    width: `${r.percentFailed}%`,
                    background: "#e74c3c",
                    transition: "width 0.3s",
                  }}
                  title={`Не доставлено: ${r.failed}`}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
